









import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import File from '@/store/models/Letter/File';
import * as api from '@/store/Services/fileService';
import * as faxService from '@/store/Services/FaxService';
import { converBase64toBlob, saveFile } from '@/util/utils';
import store from '@/store';
@Component
export default class LetterAttachment extends Vue {
    @Prop() file?: File;

    @Prop() canRemove?: boolean;
    @Prop() index?: number;
    @Prop() isFaxFile?: boolean;
    async downloadFile(){

        if(this.file === undefined)return;
        
        if(!this.isFaxFile){
            if(this.file.id ==='' || this.file.id ===  '00000000-0000-0000-0000-000000000000' || this.file.id === undefined){
                this.file.content =  this.file.content.substring(this.file.content.indexOf(',') + 1);
                const blob =  converBase64toBlob(this.file.content||"",'');
                saveFile(blob,this.file.extension);

            }else{
                const file = await api.getFile(this.file.id);
                const blob =  converBase64toBlob(file.content||"",'');
                saveFile(blob,this.file.extension);
            }
        }
        else{
                const file = await faxService.getFaxFile(this.file.id);
                const blob =  converBase64toBlob(file.content||"",'');
                saveFile(blob,this.file.extension);
        }
    }

    remove(){
        this.$emit('remove',this.index);
    }

    @Watch('file')
    onFileChanged(){
        const test =  this.file;
    }
    showFileInDetails(){
        if(this.file)
            store.state.eventHub.$emit('show-file-requested',this.file.id);
    }
    
}
